import { Box, Card, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid"

export default function ProfileHeaderSkeleton() {
    return (
        <Card className="pagelist-content" sx={{ p: 2 }}>
            <Grid container size={12}>
                <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 2 }}>
                    <Stack sx={{ alignItems: "center", justifyContent: "center" }} width={"100%"}>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Box
                                sx={{
                                    width: { xs: 100, sm: 130, md: 150, lg: 150, xl: 150 },
                                    height: { xs: 100, sm: 130, md: 150, lg: 150, xl: 150 },
                                    borderRadius: "50%",
                                    bgcolor: "#e0e0e0",
                                    mb: 1
                                }}
                            >
                                <Skeleton variant="circular" width="100%" height="100%" />
                            </Box>
                        </Box>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 9, sm: 9, md: 9, lg: 9, xl: 10 }} sx={{ pl: 2 }}>
                    <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
                        <Stack direction={"row"} spacing={1}>
                            <Skeleton variant="text" width={120} height={40} />
                            <Skeleton variant="text" width={120} height={40} />
                        </Stack>
                        <Skeleton variant="circular" width={32} height={32} />
                    </Stack>
                    <Skeleton variant="text" width={180} height={24} sx={{ mt: 1 }} />
                    <Skeleton variant="text" width={140} height={20} sx={{ mt: 1 }} />
                </Grid>
            </Grid>
        </Card>
    )
}
